import * as actions from './Actions.js';

import { Col, Row } from 'react-bootstrap';
import {
  PARAM_ENTIDADE_PROTOCOLO,
  PARAM_FORMULARIO_MENSAGEM
} from 'portaltransparencia-common/parametros/ParametrosPortalTransparencia';
import {
  addAlertNotification,
  offsidebarToggle
} from 'portaltransparencia-common/ui/Actions.js';

import Component from 'react-pure-render/component';
import DateUtils from 'portaltransparencia-common/libs/DateUtils';
import DisplayData from 'portaltransparencia-common/components/displaydata/DisplayData.react';
import DisplayDataItem from 'portaltransparencia-common/components/displaydata/DisplayDataItem.react';
import DisplayDataRow from 'portaltransparencia-common/components/displaydata/DisplayDataRow.react';
import FilterButtons from '../components/FilterButtons.react';
import FormAtendimento from '../atendimento/Form.react.js';
import { IFrame } from '../components/iframe/IFrame.react.js';
import Input from 'portaltransparencia-common/components/EloInput.react';
import { Map } from 'immutable';
import NotasExplicativas from '../notaexplicativa/Form.react';
import PageHeader from '../components/PageHeader.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import ParametroService from '../parametros/ParametroService.js';
import Processo from './Processo.react.js';
import ProcessoConsultaFiltro from './ProcessoConsultaFiltro.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import StorageService from 'portaltransparencia-common/libs/StorageService';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import TableHeaderItem from 'portaltransparencia-common/components/TableHeaderItem.react';
import { connect } from 'react-redux';
import { downloadArquivo } from '../arquivo/Actions.js';
import { getAllValuesFromUrlSearchParams } from 'portaltransparencia-common/libs/URLUtils';
import swal from 'sweetalert';

export class SolicitacaoEsic extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    findSolicitacaoEsic: PropTypes.func,
    loadTiposProcesso: PropTypes.func,
    abrirRecursoProcesso: PropTypes.func,
    location: PropTypes.object.isRequired,
    filtros: PropTypes.object,
    protocolo: PropTypes.object,
    valorParametroEntidadeProtocolo: PropTypes.string,
    parametroTipoAcessoAInformacao: PropTypes.string,
    offsidebarToggle: PropTypes.func,
    downloadArquivo: PropTypes.func,
    addAlertNotification: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      resultadoProcessoSei: null,
      numeroProcesso: ''
    };
  }

  componentDidMount() {
    const {
      location,
      findSolicitacaoEsic,
      valorParametroEntidadeProtocolo,
      addAlertNotification,
      loadTiposProcesso
    } = this.props;

    const params = getAllValuesFromUrlSearchParams(location);

    let entidade = valorParametroEntidadeProtocolo;
    if (!valorParametroEntidadeProtocolo) {
      entidade = params.entidade;
    }

    const exercicio = params.exercicio;
    const tipo = params.tipo;
    const numero = params.numero;
    const senha = params.senha;

    !this.isIntegradoSei() && loadTiposProcesso(entidade, exercicio);

    if (exercicio && numero && senha && tipo) {
      addAlertNotification(
        'Anote seus dados',
        `Número: <b>${numero} </b><br> Senha: <b>${senha}</b><br> Ano: <b>${exercicio}</b>`,
        30
      );
      findSolicitacaoEsic(entidade, exercicio, numero, senha, tipo);
    }
  }

  onClickEstatistica = () => {
    this.props.history.push('/esic/estatisticas');
  };

  isIntegradoSei = () => this.props.parametroTipoAcessoAInformacao === '4';

  onChange = event => {
    this.setState({ numeroProcesso: event.target.value });
  };

  onResetFiltro = () => {
    this.setState({ numeroProcesso: '' });
  };

  handleKeyDown = event => {
    const teclaEnter = 13;

    if (event.keyCode === teclaEnter) {
      event.preventDefault();
      this.onConsulta();
    }
  };

  onConsulta = () => {
    const { findProcessoSei } = this.props;
    const {
      entidade: { id }
    } = StorageService.getItem('userInfo');
    const value = this.refs.numeroProcesso.getValue()?.trim();
    const isValidFormat = /^[\d./]+$/.test(value);

    if (!value) {
      return swal(
        'Erro: Campo vazio',
        'O número do processo não pode estar vazio.',
        'error'
      );
    }

    if (!isValidFormat) {
      return swal(
        `Erro: Consulta inválida para o processo ${value}`,
        'O número do processo não pode conter letras.',
        'error'
      );
    }

    findProcessoSei(id, value).then(result =>
      this.setState({ resultadoProcessoSei: result.value })
    );
  };

  render() {
    const {
      filtros,
      protocolo,
      offsidebarToggle,
      onChange,
      findSolicitacaoEsic,
      downloadArquivo,
      valorParametroEntidadeProtocolo,
      abrirRecursoProcesso,
      location,
      solicitacaoEsic,
      isIntegradoOxy,
      urlProcessoExterno,
      tiposProcessos,
      parametroTipoAcessoAInformacao
    } = this.props;

    return (
      <section>
        <PageHeader location={this.props.location} />

        <div className="btn-group center mb-xs">
          {!this.isIntegradoSei() && (
            <button
              className="btn neutral icon-left"
              type="button"
              onClick={this.onClickEstatistica}
              style={{ fontSize: '15px' }}
            >
              <i className="fa fa-bar-chart"></i>
              Estatísticas
            </button>
          )}
          {[1, 2, 4].includes(Number(parametroTipoAcessoAInformacao)) && (
            <button
              className="btn neutral icon-left"
              type="button"
              onClick={offsidebarToggle}
              style={{ fontSize: '15px' }}
            >
              <i className="fa fa-plus"></i>
              Solicitar Informações
            </button>
          )}
        </div>

        {this.isIntegradoSei() && (
          <>
            <Panel
              title="Consultar e-SIC"
              mobileClose
              isForm
              expansible={false}
            >
              <Row>
                <Col xs={12} sm={8} md={9}>
                  <Input
                    id="numeroProcesso"
                    type="text"
                    ref="numeroProcesso"
                    name="numeroProcesso"
                    placeholder="Número Processo"
                    label="Número Processo"
                    onChange={this.onChange}
                    onKeyDown={this.handleKeyDown}
                    value={this.state.numeroProcesso}
                  />
                </Col>
                <Col xs={12} sm={4} md={3}>
                  <FilterButtons
                    idBtnReset="btnResetFilter"
                    onConsulta={this.onConsulta}
                    onReset={this.onResetFiltro}
                  />
                </Col>
              </Row>
            </Panel>

            {this.state.resultadoProcessoSei && (
              <Panel
                expansible={false}
                tableResponsive
                title="Resultado da Consulta"
              >
                <DisplayData border>
                  <DisplayDataRow>
                    <DisplayDataItem
                      sm={12}
                      title="Especificação"
                      value={this.state.resultadoProcessoSei?.titulo}
                      id="requerente"
                    />
                  </DisplayDataRow>
                  <DisplayDataRow>
                    <DisplayDataItem
                      sm={12}
                      title="Data"
                      value={DateUtils.formatDateTimeShort(
                        this.state.resultadoProcessoSei?.data
                      )}
                      id="requerente"
                    />
                  </DisplayDataRow>
                  <DisplayDataRow>
                    <DisplayDataItem
                      sm={12}
                      title="Tipo"
                      value={this.state.resultadoProcessoSei?.tipo?.nome}
                      id="requerente"
                    />
                  </DisplayDataRow>
                </DisplayData>

                {this.state.resultadoProcessoSei?.andamentos &&
                  this.state.resultadoProcessoSei.andamentos.length > 0 && (
                    <div style={{ marginTop: '20px' }}>
                      <div
                        style={{
                          position: 'relative',
                          textAlign: 'left',
                          margin: '25px 0 25px 0'
                        }}
                      >
                        <hr style={{ border: '1px solid #ddd', margin: '0' }} />
                        <span
                          style={{
                            position: 'absolute',
                            top: '-12px',
                            left: '0',
                            backgroundColor: '#fff',
                            padding: '0 15px',
                            fontWeight: 'bold',
                            fontSize: '14px'
                          }}
                        >
                          Andamentos do Processo
                        </span>
                      </div>

                      <div className="panel-table-outer">
                        <table className="panel-table striped fancy">
                          <TableHeader
                            empty={false}
                            text="Nenhum andamento encontrado"
                          >
                            <tr>
                              <TableHeaderItem
                                label="Data/Hora"
                                alignment="center"
                                sortable={false}
                              />
                              <TableHeaderItem
                                label="Unidade"
                                alignment="left"
                                sortable={false}
                              />
                              <TableHeaderItem
                                label="Descrição"
                                alignment="left"
                                sortable={false}
                              />
                            </tr>
                          </TableHeader>
                          <tbody>
                            {this.state.resultadoProcessoSei.andamentos.map(
                              (andamento, index) => (
                                <tr key={andamento.id || index}>
                                  <td>{andamento.dataHora}</td>
                                  <td>{andamento.unidade?.descricao}</td>
                                  <td>{andamento.descricao}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
              </Panel>
            )}
          </>
        )}

        {solicitacaoEsic && isIntegradoOxy && urlProcessoExterno && (
          <IFrame url={`${urlProcessoExterno}?iframe=true`}></IFrame>
        )}

        <NotasExplicativas pathname={location.pathname} />

        {!this.isIntegradoSei() && (
          <>
            <ProcessoConsultaFiltro
              filtros={filtros}
              onChange={onChange}
              findSolicitacaoEsic={findSolicitacaoEsic}
              tiposProcessos={tiposProcessos}
              valorParametroEntidadeProtocolo={valorParametroEntidadeProtocolo}
            />
            {protocolo && protocolo.get('processo') && (
              <Processo
                protocolo={protocolo}
                abrirRecursoProcesso={abrirRecursoProcesso}
                offsidebarToggle={offsidebarToggle}
                downloadArquivo={downloadArquivo}
              />
            )}

            {protocolo && !protocolo.get('processo') && (
              <h3 className="mb-xs center">Nenhum processo encontrado</h3>
            )}
          </>
        )}

        <FormAtendimento />
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    urlProcessoExterno: state.entidade.getIn([
      'configuracoesGerais',
      'urlProcessoExterno'
    ]),
    isIntegradoOxy: state.entidade.getIn([
      'configuracoesGerais',
      'isIntegradoOxy'
    ]),
    solicitacaoEsic: state.ui.offsidebarToggled,
    filtros: state.esic.getIn(['currentRecord'], Map({})),
    protocolo: state.esic.get('protocolo'),
    valorParametroEntidadeProtocolo: ParametroService.getValorParametro(
      state,
      PARAM_ENTIDADE_PROTOCOLO
    ),
    parametroTipoAcessoAInformacao: ParametroService.getValorParametro(
      state,
      PARAM_FORMULARIO_MENSAGEM
    ),
    tiposProcessos: state.esic.get('tiposProcessos')
  };
}

const allActions = {
  ...actions,
  offsidebarToggle,
  downloadArquivo,
  addAlertNotification
};

export default connect(mapStateToProps, allActions)(SolicitacaoEsic);
